import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDialogDirective } from '../../../directives/modal-dialog.directive';

/**
 * Modal launched from RequestDetails' "Compare with…" action button.
 *
 * Captures session B's value, then navigates to /diff?a=…&b=… so the
 * comparison view itself is bookmarkable / shareable. Anything the
 * modal needs to surface beyond the input field (recent sessions,
 * replay-linked source) is rendered inline.
 */
@Component({
  selector: 'app-diff-input-modal',
  imports: [CommonModule, FormsModule, ModalDialogDirective],
  templateUrl: './diff-input-modal.html',
})
export class DiffInputModal {
  /** Session A value — the session the user is already looking at. */
  @Input() sessionAValue: string = '';
  @Output() closePanel = new EventEmitter<void>();

  /** Bound to the input field. Pre-filled empty; user pastes session B. */
  sessionBValue: string = '';

  constructor(private readonly router: Router) {}

  /**
   * Navigate to the diff view. We do this rather than calling the
   * service from inside the modal so the resulting URL is itself
   * the canonical "this is the comparison I ran" reference.
   */
  runDiff(): void {
    const a = (this.sessionAValue || '').trim();
    const b = (this.sessionBValue || '').trim();
    if (!a || !b) return;
    this.closePanel.emit();
    this.router.navigate(['/diff'], { queryParams: { a, b } });
  }

  /** Cmd/Ctrl+Enter shortcut on the textfield. */
  onInputKeydown(ev: KeyboardEvent): void {
    if (ev.key === 'Enter' && (ev.metaKey || ev.ctrlKey)) {
      ev.preventDefault();
      this.runDiff();
    }
  }
}
